import React from "react";
import { useNavigate } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import TeamsPage from "@/pages/Teams";
import UsersPage from "@/pages/Users";
import WalletsPage from "@/pages/Wallets";

export default function TeamsUsersPage() {
  const navigate = useNavigate();

  const fromHash = (typeof window !== "undefined" ? window.location.hash : "").replace("#", "");
  const initialTab = ["users", "wallets", "teams"].includes(fromHash) ? fromHash : "teams";
  const onChange = (v) => {
    if (typeof window !== "undefined") {
      window.history.replaceState(null, "", `#${v}`);
    }
  };

  return (
    <div className="space-y-6" data-testid="teams-users-page">
      <header>
        <h1 className="text-3xl font-semibold tracking-tight text-white" style={{ fontFamily: "Outfit" }}>
          Teams, Users &amp; Wallets
        </h1>
        <p className="text-sm text-zinc-500 mt-1">Manage who works on what, the modules each team sees, and per-user wallets.</p>
      </header>

      <Tabs defaultValue={initialTab} onValueChange={onChange}>
        <TabsList className="bg-zinc-900 border border-white/10">
          <TabsTrigger value="teams" data-testid="tu-tab-teams" className="data-[state=active]:bg-white data-[state=active]:text-black">Teams</TabsTrigger>
          <TabsTrigger value="users" data-testid="tu-tab-users" className="data-[state=active]:bg-white data-[state=active]:text-black">Users</TabsTrigger>
          <TabsTrigger value="wallets" data-testid="tu-tab-wallets" className="data-[state=active]:bg-white data-[state=active]:text-black">Wallets</TabsTrigger>
        </TabsList>
        <TabsContent value="teams" className="mt-6">
          <TeamsPage />
        </TabsContent>
        <TabsContent value="users" className="mt-6">
          <UsersPage />
        </TabsContent>
        <TabsContent value="wallets" className="mt-6">
          <WalletsPage />
        </TabsContent>
      </Tabs>
    </div>
  );
}
